import { ActionIcon, Box, Button, Modal, Stack, Text } from '@mantine/core';
import classes from './LeavingModal.module.scss';
import { Actions, trackAction } from 'utils/amplitude';
import { XCircle } from '@phosphor-icons/react';

interface ILeavingModalProps {
  opened: boolean;
  onClose(): void;
  goBack: () => void;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  preCheckoutPage?: boolean;
}

const LeavingModalEmbed: React.FC<ILeavingModalProps> = ({
  opened,
  onClose,
  goBack,
  onClick,
  preCheckoutPage,
}: ILeavingModalProps) => {
  return (
    <>
      <Modal
        opened={opened}
        onClose={onClose}
        withCloseButton={false}
        centered
        size={500}
        padding={0}
        classNames={{
          content: classes.modalContent,
          body: classes.modalBody,
        }}
      >
        <ActionIcon
          title="Close"
          onClick={onClose}
          className={classes.closeButton}
          variant="transparent"
          h="auto"
          w="auto"
        >
          <XCircle size={34} weight="fill" className={classes.closeButtonIcon} />
        </ActionIcon>
        <Stack py="xl" px="lg" className={classes.contentWrapper}>
          <Text className={classes.modalTitle}>Are you sure you want to leave?</Text>
          <Box>
            <Text pb={0}>{`Your ${preCheckoutPage ? 'ticket' : ''} selection will be lost!`}</Text>
          </Box>
          <Button
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              onClose();
              onClick?.(e);
              const trackingAction = preCheckoutPage
                ? Actions.LEAVING_MODAL_CONTINUE_PRE_CHECKOUT
                : Actions.LEAVING_MODAL_CONTINUE_ADP;
              trackAction(trackingAction);
            }}
            className={classes.pinkButton}
          >
            {preCheckoutPage ? 'Checkout Now' : 'Continue Booking'}
          </Button>
          <Button
            onClick={() => {
              goBack();
              const trackingAction = preCheckoutPage
                ? Actions.LEAVING_MODAL_BACK_PRE_CHECKOUT
                : Actions.LEAVING_MODAL_BACK_ADP;
              trackAction(trackingAction);
            }}
            className={classes.outlinePinkButton}
            variant="outline"
          >
            {preCheckoutPage ? 'Back to Activity Details' : 'Back to Browsing'}
          </Button>
        </Stack>
      </Modal>
    </>
  );
};

export default LeavingModalEmbed;
